import { useState } from "react";
import { zoneArchive } from "@/mocks/blackmole";
import { chipTone } from "./tone";

export default function ZoneArchive() {
  const [idx, setIdx] = useState(0);
  const zone = zoneArchive[idx];

  return (
    <section id="zones" className="scroll-mt-24 border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-700">
              <span className="inline-block h-px w-6 bg-primary-500"></span>
              分区档案 · 各线分别归档
            </div>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              按线查看，别在一条里看岔
            </h2>
          </div>
        </div>

        <div className="mt-7 flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-50 p-1 md:gap-2 md:p-1.5">
          {zoneArchive.map((z, i) => (
            <button
              key={z.key}
              type="button"
              onClick={() => setIdx(i)}
              className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium transition-colors md:px-4 ${
                i === idx
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:bg-secondary-100 hover:text-foreground-950"
              }`}
            >
              <i className={`${z.icon} text-sm`}></i>
              {z.label}
            </button>
          ))}
        </div>

        <div className="mt-6 grid gap-5 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <ul className="divide-y divide-background-200 rounded-xl border border-background-200 bg-background-50 px-5 md:px-6">
              {zone.items.map((it, i) => (
                <li key={i}>
                  <a
                    href="#feed"
                    className="group flex cursor-pointer items-start gap-3 py-4"
                  >
                    <span className="shrink-0 whitespace-nowrap pt-0.5 text-xs font-semibold text-foreground-500">
                      {it.time}
                    </span>
                    <span
                      className={`mt-0.5 hidden shrink-0 rounded-md px-1.5 py-0.5 text-[11px] font-semibold sm:inline-block ${chipTone.secondary}`}
                    >
                      {it.tag}
                    </span>
                    <span className="flex-1 text-sm font-medium leading-relaxed text-foreground-800 transition-colors group-hover:text-primary-700">
                      {it.title}
                    </span>
                    <i className="ri-arrow-right-up-line mt-0.5 shrink-0 text-foreground-300 transition-colors group-hover:text-primary-500"></i>
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-4 flex justify-end">
              <button
                type="button"
                className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-600"
              >
                进入{zone.label}完整列表
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>

          <aside className="flex flex-col justify-between rounded-xl bg-foreground-950 p-6 text-background-100">
            <div>
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className={zone.icon}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-background-50">{zone.label}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-200/80">
                该线今日已收录 {zone.items.length * 9 + 3} 条有效线索，正在逐条核实进度与时间线，
                优先把苗头最足的转进深挖抢先版。
              </p>
            </div>
            <div className="mt-6 flex items-center justify-between rounded-lg bg-background-50/10 px-4 py-3">
              <span className="text-xs text-background-200">本线负责人</span>
              <span className="flex items-center gap-2 text-xs font-medium text-background-100">
                <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-accent-400"></span>
                值班 · 跟线中
              </span>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}